import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AdminChrome from "../components/AdminChrome";
import { useRequireAdmin } from "./AdminLogin";

export default function AdminNewsletter() {
  useRequireAdmin();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [active, setActive] = useState(0);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchAll = async (search = "") => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/subscribers", { params: { q: search || undefined, limit: 500 } });
      setItems(data.items || []);
      setTotal(data.total || 0);
      setActive(data.active || 0);
    } catch (e) { /* ignore */ }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchAll(); }, []);
  useEffect(() => {
    const t = setTimeout(() => fetchAll(q), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  const remove = async (id, email) => {
    if (!window.confirm(`Remove ${email}?`)) return;
    try { await api.delete(`/admin/subscribers/${id}`); fetchAll(q); }
    catch (e) { alert(e.response?.data?.detail || "delete failed"); }
  };

  const exportCsv = async () => {
    const token = sessionStorage.getItem("xs_admin_token");
    // Use direct fetch since axios doesn't easily download via header auth + auto-save
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/subscribers/export.csv`;
    try {
      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "xaelserpent-subscribers.csv";
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) { alert("export failed"); }
  };

  return (
    <div className="App">
      <Header />
      <main className="xs-page" data-testid="admin-newsletter-page">
        <div className="xs-container">
          <AdminChrome />
          <h1 style={{ margin: "0 0 4px", color: "#ffde16" }}>mailing list</h1>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10, margin: "18px 0" }}>
            <Stat label="subscribers" value={total} />
            <Stat label="active" value={active} />
            <Stat label="unsubscribed" value={total - active} />
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
            <input
              type="search"
              className="xs-input"
              placeholder="search by email…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              style={{ flex: "1 1 240px", minWidth: 0 }}
              data-testid="newsletter-search"
            />
            <button className="xs-btn primary" onClick={exportCsv} data-testid="newsletter-export">
              export csv
            </button>
          </div>

          <div style={{ border: "1px solid #ffde16", borderRadius: 8, overflow: "auto" }}>
            {loading && <div style={{ padding: 24, opacity: 0.6 }}>loading…</div>}
            {!loading && items.length === 0 && (
              <div style={{ padding: 24, opacity: 0.6 }}>no subscribers yet.</div>
            )}
            {!loading && items.length > 0 && (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85em" }}>
                <thead>
                  <tr style={{ background: "rgba(0,0,0,0.6)", color: "#ffde16" }}>
                    <th style={{ textAlign: "left", padding: "10px 12px" }}>email</th>
                    <th style={{ textAlign: "left", padding: "10px 12px" }}>subscribed</th>
                    <th style={{ textAlign: "left", padding: "10px 12px" }}>source</th>
                    <th style={{ textAlign: "left", padding: "10px 12px" }}>status</th>
                    <th style={{ padding: "10px 12px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((s) => (
                    <tr key={s.id} style={{ borderTop: "1px solid rgba(255,222,22,0.15)" }} data-testid={`subscriber-${s.email}`}>
                      <td style={{ padding: "10px 12px", color: "#fffbd4" }}>{s.email}</td>
                      <td style={{ padding: "10px 12px", opacity: 0.85 }}>{new Date(s.subscribed_at).toLocaleDateString()}</td>
                      <td style={{ padding: "10px 12px", opacity: 0.7 }}>{s.source || "—"}</td>
                      <td style={{ padding: "10px 12px", color: s.is_active ? "#6bff8a" : "#ff9b6b" }}>
                        {s.is_active ? "active" : "unsubscribed"}
                      </td>
                      <td style={{ padding: "10px 12px", textAlign: "right" }}>
                        <button className="xs-btn danger" style={{ padding: "4px 10px", minHeight: 0, fontSize: "0.85em" }}
                                onClick={() => remove(s.id, s.email)}>delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div style={{ marginTop: 16, padding: 14, border: "1px dashed rgba(255, 222, 22, 0.4)", borderRadius: 8, fontSize: "0.85em", color: "#fffbd4", lineHeight: 1.6 }}>
            ⚠ <strong>by design:</strong> sending is intentionally disabled here. emails are stored privately for off-site / manual use only — preventing any in-platform hijack risk.
          </div>
        </div>
      </main>
      <Footer show />
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div style={{ border: "1px solid #ffde16", borderRadius: 8, padding: "10px 14px", background: "rgba(0,0,0,0.5)" }}>
      <div style={{ fontSize: "0.7em", opacity: 0.7, letterSpacing: 1, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: "1.6em", fontWeight: "bold", color: "#ffde16" }}>{value || 0}</div>
    </div>
  );
}
